import React, { Children } from 'react';
import PropTypes from 'prop-types';
import ImageGallery from 'react-image-gallery';

import './styles/Carousel.scss';

const Carousel = ({ images, classNames }) => {
  const compareFile = (imageA, imageB) => {
    var compare = 0;
    if (imageA.originalTitle > imageB.originalTitle) {
      compare = 1;
    } else if (imageB.originalTitle > imageA.originalTitle) {
      compare = -1;
    }

    return compare;
  };

  const imagesOrdered = images.sort(compareFile);

  return (
      <div className={`carousel ${classNames}`}>
        <ImageGallery
          items={imagesOrdered}
          showThumbnails={true}
          lazyLoad={true}
          showFullscreenButton={false}
          showPlayButton={false}
        />
      </div>
  );
};

Carousel.propTypes = {
  images: PropTypes.array,
  classNames: PropTypes.string,
};

export default Carousel;



// WEBPACK FOOTER //
// ./src/components/Carousel.jsx